export const TWO_GIS_LOCAL_STORAGE_API_KEY = '2GIS_API_KEY';

export function getTwoGisApiKeyFromStorage() {
  try {
    return window.localStorage.getItem(TWO_GIS_LOCAL_STORAGE_API_KEY)?.trim() || '';
  } catch {
    return '';
  }
}

export function getTwoGisApiKey() {
  return getTwoGisApiKeyFromStorage() || import.meta.env.VITE_APP_2GIS_API_KEY;
}
